import type { ReactElement, ReactNode } from "react";
import { tokenByPath } from "../../styles/typographyTokens";
import styles from "./InspectorCallout.module.css";

const bodyTinyClass = tokenByPath("Body/Tiny")!.className;

export interface InspectorCalloutProps {
  children: ReactNode;
  className?: string;
}

/** Muted in-card note — card-bg fill, text-subtle body copy. */
export function InspectorCallout({
  children,
  className
}: InspectorCalloutProps): ReactElement {
  const classNames = [bodyTinyClass, styles.callout, className]
    .filter(Boolean)
    .join(" ");
  return <p className={classNames}>{children}</p>;
}
